import { handleResponse } from './common';

const API_URL = process.env.GATSBY_API_URL;

export const photoAssetsService = {
  persistDesignAssets,
};

async function persistDesignAssets(payload = {}) {
  if (!API_URL) {
    throw new Error('API endpoint is not configured');
  }
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  };
  return handleResponse(`${API_URL}/design-assets/persist`, requestOptions);
}
